"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campiglia-cervo": {
    "0ded851e": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "asmara": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6875554e": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "bariola": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4fdc396": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "bele": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e137c72a": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "boale": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2f90df2": [{
      "hkey": "08a701f9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "campiglia-cervo": [{
      "hkey": "08a701f9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6be367d2": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "isola-territoriale-di-andorno-micca": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2dde0a9f": [{
      "hkey": "e69c0c72",
      "slug": "riabella",
      "name": "Riabella",
      "primary": true,
      "skipSearch": false
    }],
    "localita-riabella": [{
      "hkey": "e69c0c72",
      "slug": "riabella",
      "name": "Riabella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "206e18b0": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "magnani": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10c921ba": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "mazzucchetti": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89c0d4aa": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "mulino-pianelli": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96eac276": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "piana": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec8de27f": [{
      "hkey": "e78d6791",
      "slug": "ospizio-san-giovanni",
      "name": "Ospizio San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "e78d6791",
      "slug": "ospizio-san-giovanni",
      "name": "Ospizio San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "046b6736": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "1d0832a1",
      "slug": "campiglia-cervo",
      "name": "Campiglia Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;